/**
 * return the bmi
 * The weight must be in kilograms
 * The height must be in centimeters
 */
export default function BMI(weight: number, height: number): number {
  return Math.trunc(weight / Math.pow(height / 100, 2));
}
